import { DialogDimension, DialogSize } from '@metaos/hub-sdk';

type SizeCss = {
    width: string;
    height: string;
};

export default function convertDialogSizeToCssUnit(
    size: Required<DialogSize>,
    unit: string = 'px'
): SizeCss {
    const DIM_SIZE_MAP = {
        width: new Map([
            [DialogDimension.Small, '20%'],
            [DialogDimension.Medium, '50%'],
            [DialogDimension.Large, '60%'],
        ]),
        height: new Map([
            [DialogDimension.Small, '20%'],
            [DialogDimension.Medium, '50%'],
            [DialogDimension.Large, '66%'],
        ]),
    };

    const cssSize = { width: '', height: '' };
    for (let [dim, value] of Object.entries(size)) {
        const isDimensionConst = Object.values(DialogDimension).indexOf(value) > -1;
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS7053 (31,9): Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ width: string; height: string; }'.
        // @ts-expect-error
        cssSize[dim] = isDimensionConst ? DIM_SIZE_MAP[dim].get(value) : `${value}${unit}`;
    }
    return cssSize;
}
